import { Space, Typography } from '@sravni/react-design-system';
import { Reviews } from '@sravni/react-seo';
import cn from 'classnames';
import { useMemo } from 'react';

import { ORGANIZATION_TYPES } from 'constants/reviews';

import type { TReview } from 'shared/types/TReviewsService';

import { mapReviews } from '../../lib/mapReviews';

import style from './ReviewsBlock.module.scss';
import { ReviewsBlockTexts } from './ReviewsBlock.texts';

type Props = {
  reviews: TReview[];
  organizationAlias?: string;
  heading?: string;
  className?: string;
  itemClassName?: string;
  urlParams?: Record<string, string>;
};

export const ReviewsBlock: FC<Props> = (props) => {
  const { reviews, organizationAlias, heading, className, itemClassName, urlParams = {} } = props;

  const link = useMemo(() => {
    const linkBase = organizationAlias
      ? `/${ORGANIZATION_TYPES.BANK}/${organizationAlias}/otzyvy/`
      : `/kredity/otzyvy/`;
    const paramString = new URLSearchParams(urlParams).toString();

    return paramString ? `${linkBase}?${paramString}` : linkBase;
  }, [organizationAlias, urlParams]);

  const reviewItems = useMemo(() => reviews.map(mapReviews), [reviews]);

  if (reviews.length === 0) {
    return null;
  }

  return (
    <Space
      direction="vertical"
      size={8}
    >
      <Reviews
        data-qa="Reviews"
        className={cn(style.wrapper, className)}
        reviewItemClassName={itemClassName}
        heading={heading}
        productType="kredity"
        allReviewsLink={link}
        reviews={reviewItems}
      />
      <Typography.Link
        href="/otzyvy/add/"
        strong
        target="_blank"
        className={style.addReviewLink}
      >
        {ReviewsBlockTexts.addReviewLinkLabel}
      </Typography.Link>
    </Space>
  );
};
